/** basic.alarmRule */
export default {
    alarm_radius: "Уровень охвата",
    alarm_opentState: "Состояние (вкл/выкл)",
    alarm_searPla: "Введите код устройства / название организации для поиска",
    alarm_deleteTips: "Удалить это правило предупреждения?",
    alarm_delete: "Удалить",
    alarm_drawerTitle: "Новое правило предупреждения",

    add_titleOne: "Создать правило",
    add_titlePlaOne: "Выберите диапазон предупреждения и объект",
    add_titleTwo: "Добавить получателей тревог",
    add_titlePlaTwo: "Добавить системных пользователей, связанных с правилом",
    add_titleThreePla: "Добавить временных пользователей, связанных с правилом",
    add_open: "Включить",
    add_alarmObject: "Объект предупреждения",
    add_previous: "Назад",
    add_next: "Далее",
    add_deviceID: "ID устройства",
    add_deviceName: "Название устройства",
    add_deviceOther: "Другая информация",
    add_devicePla: "Введите код устройства",
    add_eventTypeNoEmpty: "Тип события не может быть пустым",
    add_selectAlarm: "Выберите объект предупреждения",
    add_createrAlarmSucc: "Правило предупреждения создано!",
    add_createrAlarmLose: "Не удалось создать правило предупреждения!",
    add_entityRank: "Уровень организации",
    add_deviceRank: "Уровень устройства",

    sys_title: "Список системных пользователей",
    sys_searName: "Поиск по имени",
    sys_phoneName: "Поиск по номеру телефона",
    sys_searBtn: "Поиск",
    sys_clearSear: "Очистить условия",
    sys_name: "Имя",
    sys_phone: "Телефон",
    sys_role: "Роль",
    sys_addTips: "Добавить этого пользователя в правило предупреждения?",
    sys_add: "Добавить",
    sys_cardTitle: "Системные пользователи, связанные с правилом",
    sys_RemoveTips: "Удалить этого пользователя из правила предупреждения?",
    sys_removerBtn: "Удалить",
    sys_phoneFormat: "Введите корректный 11-значный номер телефона",
    sys_addSucc: "Добавлено!",
    sys_addLose: "Не удалось добавить!",
    sys_romoverSucc: "Удалено!",
    sys_removerLose: "Не удалось удалить!",

    tem_title: "Список временных пользователей",
    tem_receivePhone: "Получать звонки",
    tem_receiveSms: "Получать SMS",
    tem_cardTitle: "Временные пользователи, связанные с правилом",
}

